import { withMetadata } from '../metadata'
import { isPossiblePhoneNumber as _isPossiblePhoneNumber } from '../../core/index'

export function isPossiblePhoneNumber() {
	return withMetadata(_isPossiblePhoneNumber, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/isPossiblePhoneNumber.js
// module id = 88W2
// module chunks = 0 1